export default __webpack_public_path__ + "static/media/mobile-icon.4f16e3c4.svg";